import http from '@/axios/http'
import { getuser_id } from "@/localStorage/localStorage";
//获取参数管理列表
export function listParam() {
    const data = {
        user_id: getuser_id(),
        offset: 1,
        limit: 10
    }
    return http({
        url: '/api/ParamManager/listParam',
        method: 'post',
        data
    })
}
//查询
export function queryKeyword(keyword, offset = 1, limit = 10, sort) {
    const data = {
        user_id: 1,
        keyword: keyword,
        offset: offset,
        limit: limit,
        paramZhongwen: sort.Chinesename, //参数中文名
        paramName: sort.Englishname, //参数英文名
        updatetime: sort.paramUpdate, //更新时间\
        paramValue: sort.paramValue, // 参数值
    }
    return http({
        url: '/api/ParamManager/queryKeyword',
        method: 'post',
        data
    })
}

//添加
export function addParam(paramZhongwen, paramName, paramValue) {
    const data = {
        paramZhongwen,
        paramName,
        paramValue
    }
    return http({
        url: '/api/ParamManager/addParam',
        method: 'post',
        data
    })
}

//删除
export function delParam(id) {
    const data = {
        id
    }
    return http({
        url: '/api/ParamManager/delParam',
        method: 'post',
        data
    })
}

//修改
export function updateParam(id, paramZhongwen, paramName, paramValue) {
    const data = {
        id, //对应paramId
        paramZhongwen, //可选
        paramName, //可选
        paramValue
    }
    return http({
        url: '/api/ParamManager/updateParam',
        method: 'post',
        data
    })
}